import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get statistics cargo requests
 * */
export function* getStatisticsCargoRequests(from, until) {
    const response = yield call(api.getStatisticsCargoRequests, from, until);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_STATISTICS_CARGO_REQUESTS.SUCCESS,
            data: response.data,
        });
    }

    yield put({
        type: actionTypes.GET_STATISTICS_CARGO_REQUESTS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetStatisticsCargoRequests() {
    while (true) {
        const { from, until } = yield take(actionTypes.GET_STATISTICS_CARGO_REQUESTS.REQUEST);
        yield call(getStatisticsCargoRequests, from, until);
    }
}

export default [
    watchGetStatisticsCargoRequests,
]


// WEBPACK FOOTER //
// ./app/sagas/statistics/cargoRequests.js